export default function TermsAndConditions() {
    return (
        <div className="min-h-screen bg-cream">
            <div className="max-w-4xl mx-auto px-6 md:px-10 lg:px-16 py-16 md:py-24">
                <div className="mb-12">
                    <h1 className="font-display text-5xl md:text-6xl font-extrabold tracking-tight mb-4">
                        Terms and Conditions
                    </h1>
                    <p className="text-ink/60 font-body text-lg">
                        Last updated: June 3, 2026
                    </p>
                </div>

                <div className="prose prose-lg max-w-none font-body text-ink space-y-6">
                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">1. Agreement to Terms</h2>
                        <p>
                            By accessing and using this website and services provided by Technovale Solutions, you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">2. Use License</h2>
                        <p>
                            Permission is granted to temporarily download one copy of the materials (information or software) on Technovale Solutions' website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
                        </p>
                        <ul className="list-disc pl-6 space-y-2">
                            <li>Modifying or copying the materials</li>
                            <li>Using the materials for any commercial purpose or for any public display</li>
                            <li>Attempting to decompile or reverse engineer any software contained on the website</li>
                            <li>Removing any copyright or other proprietary notations from the materials</li>
                            <li>Transferring the materials to another person or "mirroring" the materials on any other server</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">3. Disclaimer</h2>
                        <p>
                            The materials on Technovale Solutions' website are provided on an 'as is' basis. Technovale Solutions makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">4. Limitations</h2>
                        <p>
                            In no event shall Technovale Solutions or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Technovale Solutions' website, even if we or our authorized representative has been notified orally or in writing of the possibility of such damage.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">5. Accuracy of Materials</h2>
                        <p>
                            The materials appearing on Technovale Solutions' website could include technical, typographical, or photographic errors. Technovale Solutions does not warrant that any of the materials on the website are accurate, complete, or current. Technovale Solutions may make changes to the materials contained on the website at any time without notice.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">6. Materials on Website</h2>
                        <p>
                            Technovale Solutions has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Technovale Solutions of the site. Use of any such linked website is at the user's own risk.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">7. Modifications</h2>
                        <p>
                            Technovale Solutions may revise these terms of service for the website at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">8. Governing Law</h2>
                        <p>
                            These terms and conditions are governed by and construed in accordance with the laws of India, and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">9. User Accounts</h2>
                        <p>
                            If you create an account on our website, you are responsible for maintaining the confidentiality of your account information and password, and you are responsible for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">10. Intellectual Property</h2>
                        <p>
                            All content on this website, including text, graphics, logos, images, and software, is the property of Technovale Solutions or its content suppliers and is protected by international copyright laws. Unauthorized reproduction or distribution is prohibited.
                        </p>
                    </section>

                    <section>
                        <h2 className="text-2xl font-bold font-display mb-4">11. Contact Information</h2>
                        <p>
                            If you have any questions about these Terms and Conditions, please contact us:
                        </p>
                        <div className="mt-4 p-6 bg-ink/5 border-2 border-ink/20">
                            <p className="font-bold">Technovale Solutions</p>
                            <p>Email: info@technovalesolutions.com</p>
                            <p>Phone: +91 (931) 074-5117</p>
                            <p>Address: 188, Sector 48, Gurugram, HR</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
